import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiOnboardingHelperService } from './fi-onboarding-helper.service';
import { FiOnboardingNavigationTabsComponent } from '@fi-app/fi-onboarding/fi-onboarding-navigation-tabs/fi-onboarding-navigation-tabs.component';
import { UIRouterModule } from '@uirouter/angular';
import { OnboardingStates } from '@fi-app/fi-onboarding/fi-onboarding-states';
import { FiTodoModule } from '@fi-app/fi-onboarding/fi-todo/fi-todo.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiStateSrefModule } from '@fi-shared/fi-state-proxy/state-sref/state-sref.module';
import { FiTabsModule } from '@fi-app/utilities/tabs/tabs.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiQuizModule } from '@fi-app/fi-onboarding/fi-quiz/fi-quiz.module';
import { FiOnboardingBuilderModule } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding-builder.module';
import { FiOnboardingCompletionModule } from '@fi-app/fi-onboarding/fi-onboarding-completion/fi-onboarding-completion.module';
import { FiOnboardingActiveModule } from '@fi-app/fi-onboarding/fi-onboarding-active/fi-onboarding-active.module';
import { FiOnboardingReportModule } from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report.module';
import { FiDeleteConnectedOboardingElementDialogModule } from '@fi-app/fi-onboarding/fi-delete-connected-oboarding-element-dialog/fi-delete-connected-oboarding-element-dialog.module';
import { FiOnboardingGuideModule } from '@fi-app/fi-onboarding/fi-onboarding-guide/fi-onboarding-guide.module';
import { FiOnboardingNavigationService } from '@fi-app/fi-onboarding/fi-onboarding-navigation.service';
@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild(OnboardingStates),
        MatButtonModule,
        MatIconModule,
        FiTodoModule,
        FiQuizModule,
        FiAppTextSharedModule,
        FiStateSrefModule,
        FiTabsModule,
        FiOnboardingBuilderModule,
        FiOnboardingActiveModule,
        FiOnboardingCompletionModule,
        FiOnboardingReportModule,
        FiOnboardingGuideModule,
        FiDeleteConnectedOboardingElementDialogModule,
    ],
    declarations: [FiOnboardingNavigationTabsComponent],
    providers: [FiOnboardingHelperService, FiOnboardingNavigationService],
})
export class FiOnboardingModule {}
